import {Text, Tooltip} from '@phonectas/unifon-ui-kit';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface VismaDistributionTypeProps {
	type: string;
}

const VismaDistributionType: React.FC<VismaDistributionTypeProps> = ({type}) => {
	const [t] = useTranslation();
	let placeholderText = '';
	let tooltipText: string | null = '';
	switch (type) {
	case 'P':
		placeholderText = t('Postal distribution');
		tooltipText = null;
		break;
	case 'M':
		placeholderText = t('Email distribution');
		tooltipText = null;
		break;
	case 'S':
		placeholderText = t('Suppress all document distribution');
		// eslint-disable-next-line max-len
		tooltipText = t('I.e.: generate the document pdf, but do not distribute it. Note: Norwegian Avtalegiro without notice (trekkvarsel) will have S.'
		);
		break;
	case 'DP':
		placeholderText = t('Digipost');
		tooltipText = null;
		break;
	case 'DE':
		placeholderText = t('Not in use');
		tooltipText = null;
		break;
	case 'E':
		placeholderText = t('Own distribution');
		tooltipText = t('Amili registers invoice to AR, but does not distribute it.');
		break;
	case 'H':
		placeholderText = t('Electronic invoice');
		tooltipText = t('Except types with their own distribution code, like email and Digipost.');
		break;
	case 'R':
		placeholderText = t('Reprint postal');
		tooltipText = t('Used on postal redistribution when first distribution attempt failed.');
		break;
	case 'L':
		placeholderText = t('Send to self to client');
		tooltipText = t('(i.e. to client) for manual distribution.');
		break;
	case 'SM':
		placeholderText = t('SMS');
		tooltipText = t('Used for distribution of soft reminders.');
		break;
	default:
		placeholderText = t('Unknown or no distribution type');
		break;
	}

	return (
		<span>
			{
				tooltipText === null ? (
					<Text variant="body1">
						{placeholderText}
					</Text>
				) : (
					<Tooltip text={tooltipText}>
						<span>
							<Text variant="body1">
								{placeholderText}
							</Text>
						</span>
					</Tooltip>
				)
			}
		</span>
	);
}

export default React.memo(VismaDistributionType);
